import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const InventoryGrid = ({ parts, onPartClick, onLogUsage, onRequestProcurement }) => {
  const getStatusColor = (status) => {
    switch (status) {
      case 'in_stock':
        return 'bg-success/10 text-success border-success';
      case 'low_stock':
        return 'bg-warning/10 text-warning border-warning';
      case 'out_of_stock':
        return 'bg-error/10 text-error border-error';
      case 'on_order':
        return 'bg-primary/10 text-primary border-primary';
      default:
        return 'bg-muted/10 text-muted-foreground border-muted';
    }
  };

  const getStatusLabel = (status) => {
    switch (status) {
      case 'in_stock':
        return 'In Stock';
      case 'low_stock':
        return 'Low Stock';
      case 'out_of_stock':
        return 'Out of Stock';
      case 'on_order':
        return 'On Order';
      default:
        return status;
    }
  };

  return (
    <div className="bg-card border border-border rounded-lg overflow-hidden">
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead className="bg-muted/50 border-b border-border">
            <tr>
              <th className="px-4 py-3 text-left text-sm font-semibold text-foreground">Part Number</th>
              <th className="px-4 py-3 text-left text-sm font-semibold text-foreground">Part Name</th>
              <th className="px-4 py-3 text-left text-sm font-semibold text-foreground">Category</th>
              <th className="px-4 py-3 text-left text-sm font-semibold text-foreground">Quantity</th>
              <th className="px-4 py-3 text-left text-sm font-semibold text-foreground">Status</th>
              <th className="px-4 py-3 text-left text-sm font-semibold text-foreground">Location</th>
              <th className="px-4 py-3 text-left text-sm font-semibold text-foreground">Unit Cost</th>
              <th className="px-4 py-3 text-right text-sm font-semibold text-foreground">Actions</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-border">
            {parts?.map((part) => (
              <tr
                key={part?.id}
                className="hover:bg-muted/30 transition-colors cursor-pointer"
                onClick={() => onPartClick?.(part)}
              >
                <td className="px-4 py-3 text-sm font-medium text-foreground">
                  {part?.part_number}
                </td>
                <td className="px-4 py-3">
                  <div>
                    <p className="text-sm font-medium text-foreground">{part?.part_name}</p>
                    {part?.description && (
                      <p className="text-xs text-muted-foreground truncate max-w-xs">
                        {part?.description}
                      </p>
                    )}
                  </div>
                </td>
                <td className="px-4 py-3 text-sm text-foreground">{part?.category}</td>
                <td className="px-4 py-3">
                  <div className="flex items-center space-x-2">
                    <span className="text-sm font-semibold text-foreground">{part?.quantity}</span>
                    <span className="text-xs text-muted-foreground">/ {part?.min_quantity} min</span>
                  </div>
                </td>
                <td className="px-4 py-3">
                  <span
                    className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium border ${getStatusColor(
                      part?.status
                    )}`}
                  >
                    {getStatusLabel(part?.status)}
                  </span>
                </td>
                <td className="px-4 py-3 text-sm text-foreground">{part?.location || 'N/A'}</td>
                <td className="px-4 py-3 text-sm text-foreground">
                  ${parseFloat(part?.unit_cost || 0)?.toFixed(2)}
                </td>
                <td className="px-4 py-3 text-right">
                  <div className="flex items-center justify-end space-x-2" onClick={(e) => e?.stopPropagation()}>
                    <Button
                      variant="outline"
                      size="sm"
                      onClick={(e) => {
                        e?.stopPropagation();
                        onLogUsage?.(part);
                      }}
                      disabled={part?.quantity === 0}
                    >
                      <Icon name="Minus" size={14} className="mr-1" />
                      Use
                    </Button>
                    <Button
                      variant="outline"
                      size="sm"
                      onClick={(e) => {
                        e?.stopPropagation();
                        onRequestProcurement?.(part);
                      }}
                    >
                      <Icon name="ShoppingCart" size={14} className="mr-1" />
                      Order
                    </Button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default InventoryGrid;
